
const data={
    // 规则策略
    ruleStrategy:{
        state:{
            'qiyong':{zh_CN:'启用',en_US:'Enable',vi_VN:'Kích hoạt',class:' on'},
            'tingyong':{zh_CN:'停用',en_US:'Deactivate',vi_VN:'Vô hiệu hóa',class:''}
        }
       
    },
    // 告警信息
    alarmInfo:{
        state:{
            'weichuzhi':{zh_CN:'未处置',en_US:'undisposed',vi_VN:'Chưa xử lý',class:'weichuzhi'},
            'chuzhizhong':{zh_CN:'处置中',en_US:'disposing',vi_VN:'Đang xử lý',class:'chuzhizhong'},
            'yichuzhi':{zh_CN:'已处置',en_US:'disposed',vi_VN:'Đã xử lý',class:'yichuzhi'}
        }
    }
}
export default data